import React, {useMemo} from "react";
import {TextFieldProps} from "@mui/material";
import {useContractList} from "~/apps/packages/warehouse-closure/hooks";
import {Contract} from "~/apps/packages/warehouse-closure/queries";
import {compareByField, distinctByField} from "~/apps/core/utils";
import {LoadingSelect, LoadingSelectProps} from "~/apps/packages/auto-visits/components/AutoVisitForm/LoadingSelect";


type Value = Contract;


export type ContractSelectProps = Omit<TextFieldProps, "onChange" | "value" | "select"> & {
    value?: Value
    onChange?: (value: Value) => any
};


export const ContractSelect = (props: ContractSelectProps) => {
    const {value, onChange, ...otherProps} = props;
    const {data} = useContractList();

    const handleChange = (e) => {
        const value = availableValues.find(item => item.id == e.target.value);
        onChange && onChange(value);
    }

    const availableValues = useMemo(() => {
        const availableValues: Value[] = [].concat(data).filter(Boolean);
        return distinctByField(availableValues, "id").sort(compareByField("number"));
    }, [data]);

    return (
        <LoadingSelect
            label="Договор"
            placeholder="Выбрать"
            {...otherProps as LoadingSelectProps}
            value={value ? value.id : ""}
            onChange={handleChange}
            loading={!data}
            options={[{
                value: "",
                title: <>Не выбран</>
            }].concat(availableValues?.map(item => ({
                value: item.id,
                title: (
                    <>
                        {item.group ? `${item.number} (${item.group})` : item.number}
                    </>
                )
            })))}
            empty="Нет доступных слотов"
        />
    )
}